import { ajaxJson } from "imports/ajax";
import {
    map2ChatMessageObj,
    map2ForumUserObj,
    map2ChatBriefObj
} from "imports/mapper";
import { chatActionsCreators } from "db/chat/chat.action";
import { navbarActionCreators } from "../../layouts/public-navbar/NavBarActions";
import { ForumUserActionCreators } from "db/user/user.action";
import { createTypes } from "redux-create-types";
import * as Scroll from "react-scroll";

const namespace = "chat";

export const chatActions = createTypes(
    [
        "setError",
        "toggleSpinner",
        "setChatMessageList",
        "setTotalPages",
        "setChatMessagesCount",
        "setChatReceiver",
        "setMessageContent",
        "setMessageAttachment",
        "toggleShowEmojis",
        "setProg",
        "hideEmojis",
        "clearMessageContent",
        "removeMessageAttachment",
        "setMessageAttachmentName",
        "setMessageSending",
        "increasePageNumber",
        "changeScrollPointerForChat"
    ],
    namespace
);

function setScrollToChat(chatId) {
    return dispatch => {
        dispatch({
            type: chatActions.changeScrollPointerForChat,
            payload: chatId
        });
    };
}

function increasePageNumber() {
    return dispatch => {
        dispatch({
            type: chatActions.increasePageNumber
        });
    };
}

function setMessageSending(payload) {
    return dispatch => {
        dispatch({
            type: chatActions.setMessageSending,
            payload: payload
        });
    };
}

function setMessageAttachmentName(payload) {
    return dispatch => {
        dispatch({
            type: chatActions.setMessageAttachmentName,
            payload: payload
        });
    };
}

function removeMessageAttachment() {
    return dispatch => {
        dispatch({
            type: chatActions.removeMessageAttachment
        });
    };
}

function clearMessageContent() {
    return dispatch => {
        dispatch({
            type: chatActions.clearMessageContent
        });
    };
}

function hideEmojis() {
    return dispatch => {
        dispatch({
            type: chatActions.toggleShowEmojis
        });
    };
}

function setMessageAttachment(messageAttachment) {
    return dispatch => {
        dispatch({
            type: chatActions.setMessageAttachment,
            payload: messageAttachment
        });
    };
}

function setMessageContent(messageContent) {
    return dispatch => {
        dispatch({
            type: chatActions.setMessageContent,
            payload: messageContent
        });
    };
}

function postChatMessageApiSuccess(res) {
    return dispatch => {
        dispatch(setMessageSending(false));
        dispatch(setMessageAttachment(null));
        const chatMessageObj = map2ChatMessageObj(res.data);
        dispatch(addChatMessageToList(chatMessageObj));
        dispatch(setMessageContent(""));
        Scroll.animateScroll.scrollToBottom({ containerId: "chat-section" });
        // dispatch(getChatMessagesFromApi(chatId));
    };
}

function postChatMessageApiFail(err) {
    return dispatch => {
        dispatch(setMessageSending(false));
        dispatch({
            type: chatActions.setError,
            payload: err
        });
    };
}

function postChatMessageFromApi(chatId) {
    return (dispatch, getState) => {
        let state = getState();
        let formData = new FormData();
        formData.append("text", state.ui.chatPage.messageContent);
        formData.append("chat_uid", chatId);
        if (state.ui.chatPage.messageAttachment) {
            formData.append("file", state.ui.chatPage.messageAttachment);
        }
        return ajaxJson.post("/chats/chat-messages", formData,{
            onUploadProgress:(event)=>{
                dispatch(setProg(Math.round((100 * event.loaded) / event.total)))
                // if(Math.round((100 * event.loaded) / event.total)===100){
                //     dispatch(setProg(0));
                // }
            }
        }).then(
            res => dispatch(postChatMessageApiSuccess(res)),
            err => dispatch(postChatMessageApiFail(err))
        );
    };
}

function setChatReceiver(chatReceiver) {
    return dispatch => {
        dispatch({
            type: chatActions.setChatReceiver,
            payload: chatReceiver
        });
    };
}

function setTotalPages(totalPages) {
    return dispatch => {
        dispatch({
            type: chatActions.setTotalPages,
            payload: totalPages
        });
    };
}

function setChatMessageList(chatMessagesIds) {
    return dispatch => {
        dispatch({
            type: chatActions.setChatMessageList,
            payload: chatMessagesIds
        });
    };
}

function addChatMessageToList(chatMessageObj) {
    return (dispatch, getState) => {
        dispatch(
            chatActionsCreators.addMessage(
                chatMessageObj,
                chatMessageObj.chat.uid
            )
        );
        const state = getState();
        const messageList = state.ui.chatPage.chatMessageList;
        messageList.unshift(chatMessageObj.id);
        dispatch(setChatMessageList(messageList));
    };
}

function setChatMessagesCount(chatMessagesCount) {
    return dispatch => {
        dispatch({
            type: chatActions.setChatMessagesCount,
            payload: chatMessagesCount
        });
    };
}

function getChatMessagesApiFail(err) {
    return dispatch => {
        dispatch({
            type: chatActions.setError,
            payload: err
        });
        dispatch(hideSpinner());
    };
}

function hideSpinner() {
    return dispatch => {
        dispatch({
            type: chatActions.toggleSpinner,
            payload: false
        });
    };
}

function getChatMessagesApiSuccess(res) {
    return dispatch => {
        const chatObj = map2ChatBriefObj(res.data.results[0].chat);
        const receiverObj = map2ForumUserObj(res.data.results[0].chat.receiver);
        dispatch(chatActionsCreators.create(chatObj));
        dispatch(ForumUserActionCreators.create(receiverObj));

        res.data.results.forEach(chatMessage => {
            const chatMessageObj = map2ChatMessageObj(chatMessage);
            dispatch(
                chatActionsCreators.addMessage(
                    chatMessageObj,
                    chatMessageObj.chat.uid
                )
            );
        });

        const chatMessageIds = res.data.results.map(
            c => map2ChatMessageObj(c).id
        );

        dispatch(navbarActionCreators.getUserInfoFromApi());
        dispatch(setChatReceiver(receiverObj));
        dispatch(setChatMessageList(chatMessageIds));
        dispatch(setTotalPages(res.data.total_pages));
        dispatch(setChatMessagesCount(res.data.count));
        dispatch(clearMessageContent());
        dispatch(hideSpinner());
        dispatch(setScrollToChat(chatMessageIds[0]));
    };
}

function getChatMessagesFromApi(chatUid) {
    return dispatch => {
        dispatch(showSpinner());
        return ajaxJson.get("/chats/" + chatUid + "/chat-messages").then(
            res => dispatch(getChatMessagesApiSuccess(res)),
            err => dispatch(getChatMessagesApiFail(err))
        );
    };
}

function getMoreChatMessagesFromApiSuccess(res) {
    return (dispatch, getState) => {
        const state = getState().ui.chatPage;
        dispatch(increasePageNumber());

        res.data.results.forEach(chatMessage => {
            const chatMessageObj = map2ChatMessageObj(chatMessage);
            dispatch(
                chatActionsCreators.addMessage(
                    chatMessageObj,
                    chatMessageObj.chat.uid
                )
            );
        });

        let newChatMessageIds = res.data.results.map(
            c => map2ChatMessageObj(c).id
        );
        const chatMessageIds = state.chatMessageList.concat(newChatMessageIds);
        dispatch(setTotalPages(res.data.total_pages));
        dispatch(setChatMessagesCount(res.data.count));
        dispatch(setChatMessageList(chatMessageIds));
        dispatch(setScrollToChat(newChatMessageIds[0]));
    };
}

function getMoreChatMessagesFromApiFailed(err) {
    return dispatch => {
        return dispatch => {
            dispatch({
                type: chatActions.setError,
                payload: err
            });
        };
    };
}

function getMoreChatMessagesFromApi(chatUid) {
    return (dispatch, getState) => {
        const state = getState().ui.chatPage;
        return ajaxJson
            .get(`/chats/${chatUid}/chat-messages`, {
                params: {
                    page: state.chatMessagesPage + 1
                }
            })
            .then(
                res => dispatch(getMoreChatMessagesFromApiSuccess(res)),
                err => dispatch(getMoreChatMessagesFromApiSuccess(err))
            );
    };
}

function showSpinner() {
    return dispatch => {
        dispatch({
            type: chatActions.toggleSpinner,
            payload: true
        });
    };
}

function toggleShowEmojis(payload) {
    return dispatch => {
        dispatch({
            type: chatActions.toggleShowEmojis,
            payload: payload
        });
    };
}


function setProg(payload) {
    return dispatch => {
        dispatch({
            type: chatActions.setProg,
            payload: payload
        });
    };
}

export const chatActionCreators = {
    getChatMessagesFromApi,
    setMessageContent,
    postChatMessageFromApi,
    setMessageAttachment,
    toggleShowEmojis,
    setProg,
    hideEmojis,
    removeMessageAttachment,
    setMessageAttachmentName,
    setMessageSending,
    getMoreChatMessagesFromApi
};
